import React, { useEffect, useState } from "react";
import { headers, url } from "../../utils/const";
import PosNavigation from "../lotery/pos-navigation";
import "./historial.css";

function Historial() {
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    fetch(`${url}/run`, { method: "get", headers })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data?.message || "No se pudieron cargar los resultados");
        }
        if (active) setHistorial(Array.isArray(data) ? data : []);
      })
      .catch((cause) => {
        if (active) setError(cause?.message || "No se pudieron cargar los resultados");
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="queen-pos-page">
      <div className="queen-pos reina-section-shell">
        <PosNavigation active="history" />
        <main className="reina-section-main noPrint">
          <section className="reina-panel">
            <div className="reina-page-heading">
              <div>
                <span className="reina-eyebrow">Historial oficial</span>
                <h2>Resultados de sorteos</h2>
                <p>Consulta los números ganadores registrados en los sorteos recientes de La Reina.</p>
              </div>
              <span className="reina-badge">{historial.length} resultados</span>
            </div>

            {error && <div className="reina-status is-error" role="alert">{error}</div>}
            {loading && <div className="reina-status" role="status">Cargando resultados...</div>}

            {!loading && !error && (
              <div className="reina-table-wrap">
                <table className="table reina-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Sorteo</th>
                      <th>Fecha</th>
                      <th>1ra</th>
                      <th>2da</th>
                      <th>3ra</th>
                    </tr>
                  </thead>
                  <tbody>
                    {historial.length > 0 ? (
                      historial.map((item, index) => (
                        <tr key={item._id || item.num || index}>
                          <td>{index + 1}</td>
                          <td><strong>{item.num}</strong></td>
                          <td>{new Date(item.date).toLocaleDateString("es-ES")}</td>
                          <td>{item.dogWinners?.first || "—"}</td>
                          <td>{item.dogWinners?.second || "—"}</td>
                          <td>{item.dogWinners?.third || "—"}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="reina-empty">No hay resultados disponibles.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </section>
        </main>
      </div>
    </div>
  );
}

export default Historial;
